import { useBooleanFeatureFlag } from '@confluence/session-data';
export const WHITEBOARD_EMOJI_TITLE_FF = 'confluence.frontend.whiteboard.emoji.titles';

export const useShouldShowEmojiTitle = (contentType: string | null | undefined) => {
	const isWhiteboardEmojiFFEnabled: boolean = useBooleanFeatureFlag(WHITEBOARD_EMOJI_TITLE_FF);
	return isWhiteboardEmojiFFEnabled && contentType === 'whiteboard';
};
